module.exports = __webpack_public_path__ + "img/separateur-gris-vertical.a9f231e2.png";